
import { defineComponent, ref, computed, onMounted } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import strategyApi from '@/api/strategy'
import { zh_tran, objTran } from '@/utils/lang.js'

interface CategoryItem {
  category: number
  internalName: string
  name: string
  sortOrder: number
}

export default defineComponent({
  name: 'StrategyPage',
  setup() {
    const router = useRouter()
    const route = useRoute()
    const categoryList = ref<CategoryItem[]>([])
    const showRiskModal = ref(false)
    const isRiskHover = ref(false)

    const lang = (route.query['Accept-Language'] as string) || 'zh-Hans'
    const isTraditional = computed(() => lang === 'zh-Hant')

    function tran(text: string): string {
      if (!text) return text
      if (isTraditional.value) return (text as any).tran()
      return text
    }

    const isSubscriptionActive = computed(() => route.name === 'strategySubscription')
    const activeCategoryName = computed(() => route.params.category as string || '')

    const goSubscription = () => {
      router.push({ name: 'strategySubscription', query: route.query })
    }

    const goCategory = (category: string) => {
      router.push({ name: 'strategyCategory', params: { category }, query: route.query })
    }

    const fetchCategoryList = async () => {
      try {
        const res: any = await strategyApi.getCategoryList()
        if (res?.data?.list) {
          categoryList.value = isTraditional.value ? objTran('t', res.data.list) : res.data.list
        }
      } catch (e) {
        console.error('获取策略分类失败', e)
      }
    }

    onMounted(async () => {
      if (isTraditional.value) zh_tran('t')
      await fetchCategoryList()
      // 默认跳转到我的订阅
      if (route.path === '/strategy' || route.path === '/strategy/') {
        router.replace({ name: 'strategySubscription', query: route.query })
      }
    })

    return {
      categoryList,
      isSubscriptionActive,
      activeCategoryName,
      goSubscription,
      goCategory,
      tran,
      isDark: computed(() => route.query.theme !== 'light'),
      showRiskModal,
      isRiskHover
    }
  }
})
